
import { Tabs } from 'antd';
import { GovardMultiPane } from '../../../shared/ui/GovardMultiPane';
import { GovardEntityHeader } from '../../../shared/ui/GovardEntityHeader';
import { ContactDossier } from '../components/ContactDossier';
import type { Contact } from '../types';

// Mock data for MVP demonstration
const MOCK_CONTACT: Contact = {
  id: 'c1',
  workspaceId: 'w1',
  firstName: 'Elon',
  lastName: 'Musk',
  email: 'elon@tesla.com',
  phone: '+1 555 0100',
  company: 'Tesla, SpaceX',
  role: 'CEO',
  source: 'Inbound',
  tags: ['VIP', 'Tech'],
  createdAt: new Date(),
  updatedAt: new Date(),
};

/**
 * ContactCardPage implements the V6 AST Blueprint for an EntityWorkspace.
 * It uses the GovardMultiPane layout to enforce the standard 3-pane structure.
 */
export function ContactCardPage() {
  const contact = MOCK_CONTACT;

  // Contact Hub (Center Pane)
  const renderHubPane = () => (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <GovardEntityHeader
        title={`${contact.firstName} ${contact.lastName}`}
        breadcrumbs="Contacts / Contact Profile"
      />
      <div style={{ padding: '0 24px', flex: 1, overflowY: 'auto' }}>
        <Tabs
          items={[
            {
              key: 'activity',
              label: 'Activity',
              children: <div style={{ paddingTop: '16px' }}>Activity Timeline Placeholder</div>,
            },
            {
              key: 'deals',
              label: 'Deals',
              children: <div style={{ paddingTop: '16px' }}>Deals Table Placeholder</div>,
            },
            {
              key: 'notes',
              label: 'Notes',
              children: <div style={{ paddingTop: '16px' }}>Notes Editor Placeholder</div>,
            },
          ]}
        />
      </div>
    </div>
  );

  return (
    <GovardMultiPane
      isEdgeToEdge={true}
      dossierPane={<ContactDossier contact={contact} />}
      hubPane={renderHubPane()}
    />
  );
}
